// removed by extract-text-webpack-plugin
module.exports = {"container":"_8alHoiBdYIn49MtHuZhc8"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fc03230","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/chat-window/chat-window.less
// module id = cBHr
// module chunks = 1